import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import UserSetting from "@app/enum/UserSetting";
import { getUserSettingValue } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./NoNotification.module.scss";

interface Props {
  // need to use settings to figure out should we change UI
  onGoToSettings: () => void;
  settingsExists: boolean;
}

const NoNotification = ({ onGoToSettings, settingsExists }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div>
        {settingsExists
          ? intl.formatMessage({
              id: "navbar.notifications.list.noNotification.settingExists",
              defaultMessage: "No notifications yet",
              description: "Navbar Notifications - list - no notification - setting exists",
            })
          : intl.formatMessage({
              id: "navbar.notifications.list.noNotification.settingDoesntExists",
              defaultMessage: "You haven’t opted in to Notifications yet",
              description: "Navbar Notifications - list - no notification - setting doesn't exist",
            })}
      </div>
      {!settingsExists && (
        <Button onClick={onGoToSettings} type="primary">
          {intl.formatMessage({
            id: "navbar.notifications.list.noNotification.goToSettings",
            defaultMessage: "Go to Notification Preferences",
            description:
              "Navbar Notifications - list - no notification - Go to Notification Preferences",
          })}
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  settingsExists: !!getUserSettingValue(state, UserSetting.EMAIL_NOTIFICATION_SETTINGS),
});

export default connect(mapStateToProps)(NoNotification);
